import { isProduction } from "services/helper/EnvHelper";
import configureStoreDev from "./configureStore.dev";
import configureStoreProd from "./configureStore.prod";

export default isProduction() ? configureStoreProd : configureStoreDev;
